import React, { useState } from 'react';
import { Spin, Alert } from 'antd';
import { useD314Query } from './hooks/useD314Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/d314Api';
import './D314Form.css';

/**
 * Get default date range: dateFrom = 1 year ago, dateTo = today.
 */
function getDefaultDates(): { from: string; to: string } {
  const now = new Date();
  const toStr = now.toISOString().substring(0, 10);
  const past = new Date(now);
  past.setFullYear(past.getFullYear() - 1);
  const fromStr = past.toISOString().substring(0, 10);
  return { from: fromStr, to: toStr };
}

const D314Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = useD314Query();

  const defaults = getDefaultDates();
  const [itemFrom, setItemFrom] = useState('');
  const [itemTo, setItemTo] = useState('');
  const [dateFrom, setDateFrom] = useState(defaults.from);
  const [dateTo, setDateTo] = useState(defaults.to);

  const handleQuery = () => {
    const req: QueryRequest = {
      itemFrom: itemFrom.trim(),
      itemTo: itemTo.trim() || 'zzzzzzzzzzzz',
      dateFrom: dateFrom.trim(),
      dateTo: dateTo.trim(),
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="d314-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          產品進貨成本表 (pwd314f1)
        </h2>

        <QueryParams
          itemFrom={itemFrom}
          itemTo={itemTo}
          dateFrom={dateFrom}
          dateTo={dateTo}
          loading={loading}
          onItemFromChange={setItemFrom}
          onItemToChange={setItemTo}
          onDateFromChange={setDateFrom}
          onDateToChange={setDateTo}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的進貨成本資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default D314Form;
